import "./gtm.js";
import Vue from "vue";
import Widget from "./Widget.vue";

new Vue({
  render: h => h(Widget)
}).$mount("#app");
